import { Transition } from '@headlessui/react';
import { XCircleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Fragment, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { hideNotification } from 'src/store/slices/globalnotification';

export const GlobalNotification: React.FC = () => {
  const notification = useAppSelector((state) => state.globalNotification);
  const dispatch = useAppDispatch();

  const closeNotification = () => {
    dispatch(hideNotification());
  };

  useEffect(() => {
    if (notification.show == true) {
      setTimeout(() => {
        closeNotification();
      }, 8000);
    }
  }, [notification]);

  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 z-50 sm:items-start sm:p-6"
      >
        <div className="flex w-full flex-col items-center space-y-4 mt-20 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={notification.show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className={`pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg ring-1 ${
                notification.type === 'success'
                  ? 'bg-green-100 ring-green-400'
                  : notification.type === 'error'
                  ? 'bg-red-100 ring-red-400'
                  : notification.type === 'info'
                  ? 'bg-blue-100 ring-blue-400'
                  : 'bg-white ring-black'
              } ring-opacity-5`}
            >
              <div className="p-4">
                <div className="flex items-start">
                  {notification.type == 'success' && (
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                  )}

                  {notification.type == 'error' && (
                    <div className="flex-shrink-0">
                      <XCircleIcon
                        className="h-6 w-6 text-red-400"
                        aria-hidden="true"
                      />
                    </div>
                  )}

                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    {notification.title && (
                      <p className="text-sm font-medium text-gray-900">
                        {notification.title}
                      </p>
                    )}
                    {notification.subtitle && (
                      <p className="mt-1 text-sm text-gray-500">
                        {notification.subtitle}
                      </p>
                    )}
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                    <button
                      type="button"
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={() => {
                        closeNotification();
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
};
